import React, { useEffect } from 'react';
import $ from 'jquery';
import '../utils/responsiveslides';

const VisualItem = props => (
	<li>
		<img src={props.src} alt={props.alt} />
	</li>
);

const VisualItem2 = props => {
	const _openBrWindow = theURL => {
		if (theURL === '') {
			return;
		}
		const PageSetting =
			'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=679';
		window.open(theURL, '', PageSetting);
	};

	const liStyle = {
		background: 'url(' + props.src + ') top no-repeat'
	};
	const spanClass = props.alt == '' ? '' : 'link';

	return (
		<li>
			<span style={liStyle} onClick={_openBrWindow(props.alt)} className={spanClass} />
		</li>
	);
};

export default function Visual2 ({visualList, Type}) {
	useEffect(()=>{
		$('#slider4').responsiveSlides({
			pager: true,
			nav: true,
			speed: 500,
			namespace: 'callbacks',
			before: () => {
				$('.events').append('<li>before event fired.</li>');
			},
			after: () => {
				$('.events').append('<li>after event fired.</li>');
			}
		});
	},[]);
	let visuals = null;
	if (visualList && visualList.length && visualList.length > 1) {
		visuals = visualList.map((v, i) => {
			if (Type == '1') {
				return <VisualItem key={i} src={v.src} alt={v.alt} />;
			} else if (Type == '2') {
				return <VisualItem2 key={i} src={v.src} alt={v.alt} />;
			}
		});
	}
	else {
		const v = visualList;
		if (Type == '1') {
			visuals = <VisualItem key={0} src={v.src} alt={v.alt} />;
		} else if (Type == '2') {
			visuals = <VisualItem2 key={0} src={v.src} alt={v.alt} />;
		}
	}
	return (
		<div className="callbacks_container">
			<ul className="rslides" id="slider4">
				{visuals}
			</ul>
		</div>
	);
}
